module.exports = __webpack_public_path__ + "img/home-pic-8.0d06c9f3.jpg";